/**
 * Feature flags convention: go/frontend-feature-flags. Please ensure integration tests are still working afterwards.
 */

import { UNSAFE_noExposureExp, expValEquals } from '@atlassian/jira-feature-experiments';
import { ff, getFeatureFlagValue } from '@atlassian/jira-feature-flagging';

// Add your feature flag name as a constant
const ERROR_TRACKING_ENABLED = 'fe.platform.error.tracking.enabled';

const BACKLOG_REALTIME_DEBOUNCE_INTERVAL = 'jsw.nextgen.backlog.realtime.debounce.interval';

const CRITICAL_QUERY_WITH_RELAY = 'jsw.perf.critical-backlog-with-relay';
const LONGTASKS_REFACTOR_ENABLED = 'jsw.long-tasks-refactor';
const BACKLOG_WITH_RELAY_ENABLED = 'jsw.perf.critical-backlog-with-relay';
const EMIT_APDEX_ON_ANIMATION_FRAME = 'jsw.perf.board-backlog-emit-apdex-on-animation-frame';
const BACKLOG_POLLING_INTERVAL = 'jsw.nextgen.backlog.polling.interval';

const ALTERNATE_TTI = 'jsw-measure-tti-alternate';

const NEW_INLINE_EDIT_ESTMATE_COMPONENTS = 'jsw.perf.new-inline-edit-estimate-components';

const JSW_BACKLOG_CARD_ESTIMATES_A11Y_IMPROVEMENTS =
	'sea-2524-backlog-card-estimates-a11y-improvements_1ljqi';

const FETCH_BACKLOG_CHILD_ISSUES_DATA = 'sea-2127-backlog-fetch-child-issues-data-tmps_obopa';

const UIF_STATSIG_EXPOSURES_UPDATES = 'jsw.perf.uif.statsig-exposures-update';

export const JSW_SPRINT_PLANNING_WHITEBOARDS_ENTRYPOINT = 'jsw_sprint_planning_whiteboards';

// Add your feature flag constant to this list so that it can be picked up by cypress tests and storybook
export const backlogFeatureFlagNames: string[] = [
	ERROR_TRACKING_ENABLED,
	CRITICAL_QUERY_WITH_RELAY,
	BACKLOG_WITH_RELAY_ENABLED,
	LONGTASKS_REFACTOR_ENABLED,
	ALTERNATE_TTI,
	EMIT_APDEX_ON_ANIMATION_FRAME,
	BACKLOG_POLLING_INTERVAL,
	NEW_INLINE_EDIT_ESTMATE_COMPONENTS,
	JSW_BACKLOG_CARD_ESTIMATES_A11Y_IMPROVEMENTS,
	FETCH_BACKLOG_CHILD_ISSUES_DATA,
	'modify-cmp-backlog-epic-panel-in-progress-bar-tooltips_gusjl',
	UIF_STATSIG_EXPOSURES_UPDATES,
	JSW_SPRINT_PLANNING_WHITEBOARDS_ENTRYPOINT,
	'show-board-filter-permission-message-to-admins_iqh25',
	'thor-add-original-estimate-to-list-of-available-fields_o4qx6',
	'render-time-tracking-field-in-bulk-edit_nqgx7',
];

export const getBacklogRealtimeDebounceIntervalMillisecs = (): number =>
	getFeatureFlagValue(BACKLOG_REALTIME_DEBOUNCE_INTERVAL, 500);

export const isErrorTrackingEnabledWithSentry = (): boolean =>
	ff('fe.platform.error.tracking.enabled');

export const isRelayQueryEnabled = () => ff('jsw.perf.critical-backlog-with-relay');

export const isBacklogWithRelayEnabled = () => ff('jsw.perf.critical-backlog-with-relay');

// <pyamada>
export const isLongTasksRefactorEnabled = () => ff('jsw.long-tasks-refactor');

export const isAlternateTTIMeasurementEnabled = () => ff('jsw-measure-tti-alternate');
// </pyamada>

export const emitApdexOnAnimationFrame = () =>
	ff('jsw.perf.board-backlog-emit-apdex-on-animation-frame');

export const getBacklogPollingInterval = () =>
	getFeatureFlagValue(BACKLOG_POLLING_INTERVAL, 600000);

// <nalvarez>
export const isNewInlineEditEstimateComponentsEnabled = () =>
	ff('jsw.perf.new-inline-edit-estimate-components');
// </nalvarez>

// <tjoy>

// eslint-disable-next-line jira/ff/inline-usage
export function isInAddPeopleButtonOpenTMPExperimentCohort(): boolean {
	return expValEquals('open_invite_for_open_tmp_projects', 'cohort', 'experiment');
}
// </tjoy>

// <lward3>
export const isBacklogCardEstimatesA11yImprovementsEnabled = () =>
	ff('sea-2524-backlog-card-estimates-a11y-improvements_1ljqi');
// </lward3>

export const isEpicPanelInProgressBarTooltipsUpdateEnabled = () =>
	ff('modify-cmp-backlog-epic-panel-in-progress-bar-tooltips_gusjl');

// <jyan>
// </jyan>

// <fzeng>
export const isViewSettingAsPanelExpEnabledWithNoExposure = () => {
	const [expConfig] = UNSAFE_noExposureExp('jsw_additional_card_fields_in_view_settings');
	return expConfig.get('cohort', 'not-enrolled') === 'variation';
};
// </fzeng>

// <hyustiawan>
export const isIssueTypeInContextExperimentEnabled = () => {
	const [expConfig] = UNSAFE_noExposureExp('jsw_config_in_context_issue_types_m2');
	return (
		// kill switch
		ff('config-in-context-issue-type-m2-flag_bddyq') &&
		// check if user is in test / experimentation cohort
		expConfig.get('inlineIssueTypeConfigEnabled', false)
	);
};
// </hyustiawan>
